/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Unit rent filter with support for different rent types.
 * Extends RangeFilter to include a type field that determines which rent metric to filter on.
 */
export type UnitRentFilter = {
    /**
     * Minimum value for the range (inclusive). Properties with values below this threshold
     * will be excluded from results. Set to `null` to omit the minimum constraint.
     */
    min: number | null;
    /**
     * Maximum value for the range (inclusive). Properties with values above this threshold
     * will be excluded from results. Set to `null` to omit the maximum constraint.
     */
    max: number | null;
    /**
     * Whether to include properties that have `null` (missing/unknown) values for this field.
     *
     * **Default behavior**: `false` - properties with missing data are excluded
     * **When `true`**: properties with missing data are included in results
     *
     * **Use Cases**:
     * - `false`: Only include properties with known values (stricter filtering)
     * - `true`: Include properties even if this data point is unknown (broader results)
     */
    allow_null?: boolean | null;
    /**
     * Type of rent to filter on.
     * - `asking_rent`: The asking/list price for the unit (units_history.price)
     * - `asking_rent_psf`: Asking rent per square foot (units_history.price / units.sqft)
     * - `effective_rent`: Effective rent after concessions (units_history.effective_price)
     * - `effective_rent_psf`: Effective rent per square foot (units_history.effective_price / units.sqft)
     */
    type?: UnitRentFilter.type;
};
export namespace UnitRentFilter {
    /**
     * Type of rent to filter on.
     * - `asking_rent`: The asking/list price for the unit (units_history.price)
     * - `asking_rent_psf`: Asking rent per square foot (units_history.price / units.sqft)
     * - `effective_rent`: Effective rent after concessions (units_history.effective_price)
     * - `effective_rent_psf`: Effective rent per square foot (units_history.effective_price / units.sqft)
     */
    export enum type {
        ASKING_RENT = 'asking_rent',
        ASKING_RENT_PSF = 'asking_rent_psf',
        EFFECTIVE_RENT = 'effective_rent',
        EFFECTIVE_RENT_PSF = 'effective_rent_psf',
    }
}

